import { HermesResponse } from 'ha/modules/Hermes';

import { RouteShape } from '../types';

export default function(info: HermesResponse['info']): RouteShape {
  return {
    pathname: info.path,
    pageName: info.type,
    isRouteExists: true,
    props: {
      hasData: info.hasData,
      canonical: info.meta.canonical,
      alternateHrefs: info.meta.alternateHrefs,
    },
  };
}
